export enum RequiredDocs {
  CompanyLogo = 'Company_Logo',
  GSTRegistrationDocument = 'GST_Registration_Document',
  CompanyRegistrationDocument = 'Company_Registration_Document',
}
export enum EmployeeDocs {
  Pan_Card = 'Pan_Card',
  Aadhar_Card = 'Aadhar_Card',
  Reliving_Letter = 'Reliving_Letter',
  Other_Documents = 'Other_Documents',
  // Mark_Sheet_10th = 'Mark_Sheet_10th',
  // Mark_Sheet_12th = 'Mark_Sheet_12th',
  // Character_Certificate = 'Character_Certificate',
  // Experience_Letter = 'Experience_Letter',
  // Pay_Slip = 'Pay_Slip',
  // Pass_Book = 'Pass_Book',
  // Cancelled_Cheque = 'Cancelled_Cheque',
  // ITI_Diploma = 'ITI_Diploma',
  // BTech = 'B.Tech',
  // Electrical_license = 'Electrical_license',
  // Other_Education = 'Other_Education',
}
